export default function rispoGrid() {
  const grids = document.querySelectorAll(".js-rispo-grid");

  if (!grids.length || typeof rispoManifestations === "undefined") {
    return;
  }

  grids.forEach((grid) => {
    const results = grid.querySelector(".js-rispo-grid-results");
    const taxonomy = grid.dataset.taxonomy || "categorie_manifestations";
    const postsPerPage = grid.dataset.postsPerPage || "9";

    let currentTerm = "";
    let currentPage = 1;
    let isLoading = false;

    const loadGrid = async () => {
      if (isLoading) return;

      isLoading = true;
      grid.classList.add("is-loading");

      const url = new URL(rispoManifestations.restUrl);
      url.searchParams.set("taxonomy", taxonomy);
      url.searchParams.set("posts_per_page", postsPerPage);
      url.searchParams.set("paged", String(currentPage));

      if (currentTerm) {
        url.searchParams.set("term", currentTerm);
      }

      try {
        const response = await fetch(url.toString(), {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Erreur réseau");
        }

        const data = await response.json();

        if (data && data.html) {
          results.innerHTML = data.html;
          bindPagination();
        }
      } catch (error) {
        console.error(error);
      } finally {
        isLoading = false;
        grid.classList.remove("is-loading");
      }
    };

    const bindFilters = () => {
      const filters = grid.querySelectorAll(".js-rispo-grid-filter");

      filters.forEach((filter) => {
        filter.addEventListener("click", (event) => {
          event.preventDefault();

          currentTerm = filter.dataset.term || "";
          currentPage = 1;

          filters.forEach((item) => item.classList.remove("is-active"));
          filter.classList.add("is-active");

          loadGrid();
        });
      });
    };

    const bindPagination = () => {
      const paginationLinks = results.querySelectorAll(".page-numbers");

      paginationLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault();

          const href = link.getAttribute("href");
          if (!href) return;

          try {
            const parsed = new URL(href, window.location.origin);
            const paged =
              parsed.searchParams.get("paged") ||
              parsed.searchParams.get("page");

            if (paged) {
              currentPage = parseInt(paged, 10) || 1;
            } else {
              const match = href.match(/\/page\/(\d+)/);
              currentPage = match ? parseInt(match[1], 10) : 1;
            }

            loadGrid();
          } catch (e) {
            console.error(e);
          }
        });
      });
    };

    bindFilters();
    bindPagination();
  });
}
